import React from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Breadcrumb, message, Spin } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { useMutation, useQuery } from '@apollo/client';
import fp from 'lodash/fp';
import {
  UPDATE_APPROVAL_ROUTE_TEMPLATE,
  GET_APPROVAL_ROUTE_TEMPLATES,
} from '../../../gql/approvalRoutes';
import ApprovalRouteForm from './components/ApprovalRouteForm';

const formatApprovalStepTemplates = fp.pipe(
  fp.get('approvalStepTemplates'),
  fp.map((o) => {
    if (o.approverListingType !== 'APPOINTED') {
      return fp.omit('appointedApprover')(o);
    }
    return o;
  }),
  fp.map(fp.omit('__typename'))
);

const EditApprovalRoute = () => {
  const { id } = useParams();
  const history = useHistory();
  const { data, loading } = useQuery(GET_APPROVAL_ROUTE_TEMPLATES, {
    variables: {
      state: 'ALL',
      ids: [id],
    },
  });
  const [update, { loading: updateLoading }] = useMutation(
    UPDATE_APPROVAL_ROUTE_TEMPLATE,
    {
      refetchQueries: [
        {
          query: GET_APPROVAL_ROUTE_TEMPLATES,
          variables: { state: 'ALL', ids: [id] },
        },
        {
          query: GET_APPROVAL_ROUTE_TEMPLATES,
          variables: { state: 'ACTIVE' },
        },
      ],
      onCompleted: ({ updateApprovalRouteTemplate }) => {
        message.success(
          `${updateApprovalRouteTemplate.name} successfully edited`
        );
        history.push('/system-setting/approval-routes');
      },
      onError: (err) => {
        console.log(err);
      },
    }
  );
  const initialValues = loading
    ? {}
    : {
        name: data.approvalRouteTemplates[0].name,
        description: data.approvalRouteTemplates[0].description,
        active: !data.approvalRouteTemplates[0].disabled,
        approvalStepTemplates:
          data.approvalRouteTemplates[0].approvalStepTemplates,
      };

  return (
    <PageContainer
      header={{
        title: 'Edit Approval Route Template',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/approval-routes">
                Approval Route Templates
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Edit Approval Route Template</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
      loading={loading}
    >
      <Spin spinning={updateLoading} tip="updateing...">
        <ApprovalRouteForm
          initialValues={initialValues}
          isEdit={true}
          onFinish={(values) => {
            update({
              variables: {
                input: {
                  id,
                  name: values.name,
                  description: values.description,
                  disabled: !values.active,
                  approvalStepTemplates: formatApprovalStepTemplates(values),
                  deleted: false,
                },
              },
            });
          }}
        />
      </Spin>
    </PageContainer>
  );
};

export default EditApprovalRoute;
